import { Col, Tag, Tooltip, Typography } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { Button, Loader, ProfileImage } from '../../../components'
import { FiMapPin } from "react-icons/fi";
import { SlCalender } from "react-icons/sl";
import '../style.css'; // Assuming the CSS file is named styles.css and is in the same directory
import { useParams, useNavigate } from 'react-router';
import { ApiCaller, Colors } from '../../../config';
import { FaCheck } from 'react-icons/fa';
import { FaPoundSign } from "react-icons/fa";
import moment from 'moment';

const statusMap = {
    0: "Pending",
    1: "Completed",
    2: "Rejected",
    3: "Accepted",
    4: "In-progress",
    5: "Admin Assign"
};

// what to render in case of sp.
function spDetailCheck(bookingDetailData) {
    let quoteDetail = null;
    let bookingStatus = bookingDetailData?.bookingStatus;

    if (bookingDetailData?.bookingType == 'DIRECT') {
        // completed, in-progress - find the ACCEPTED quote
        if (bookingStatus == 1 || bookingStatus == 4) {
            quoteDetail = bookingDetailData?.quotes?.find((quote) => quote?.status === "ACCEPTED") || null;
        }
        // accepted
        else if (bookingStatus == 3) {
            quoteDetail = bookingDetailData?.quotes?.length > 0 ? bookingDetailData?.quotes[0] : null;
        }
        // pending
        else if (bookingStatus == 0 || bookingStatus == 5) {
            quoteDetail = bookingDetailData?.quotes?.length > 0 ? bookingDetailData?.quotes[0] : null;
        }
        // rejected
        else if (bookingStatus == 2) {
            quoteDetail = bookingDetailData?.quotes?.length > 0 ? bookingDetailData?.quotes[0] : null;
        }
    }
    else {
        // completed, in-progress
        if (bookingStatus == 1 || bookingStatus == 4) {
            quoteDetail = bookingDetailData?.quotes?.find((quote) => quote?.status === "ACCEPTED");
        }
        // pending
        else if (bookingStatus == 0 || bookingStatus == 5) {
            quoteDetail = bookingDetailData?.quotes;
        }
        // rejected
        else if (bookingStatus == 2) {
            quoteDetail = bookingDetailData?.quotes || [];
        }
    }

    return quoteDetail;
}

const BookingCard = () => {

    // Helper function to get status color
    const getQuoteStatusColor = (status) => {
        switch (status?.toUpperCase()) {
            case 'PENDING':
                return '#FAB700';
            case 'ACCEPTED':
                return '#00B517';
            case 'REJECTED':
                return '#FF4D4F';
            default:
                return '#8C8C8C';
        }
    };

    const { Title, Text } = Typography;

    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [isProfileNavigating, setIsProfileNavigating] = useState(false);
    const [bookingDetailData, setBookingDetailData] = useState(null);
    console.log(bookingDetailData?.bookingStatus == 1, "bookingDetailData");

    const now = moment();


    useEffect(() => {
        (async () => {
            setIsLoading(true)
            try {
                let resp = await ApiCaller.Get(`/admin/booking/${id}`);
                setBookingDetailData(resp?.data?.data?.booking)
            }
            catch (error) {
                console.log(error)
            }
            finally {
                setIsLoading(false)
            }
        })()
    }, [id])

    const quoteDetail = useMemo(() => spDetailCheck(bookingDetailData), [bookingDetailData]);
    console.log(quoteDetail, "quoteDetail");


    const serviceUserHandler = async () => {
        const serviceUserId = bookingDetailData?.serviceUser?.id;
        if (!serviceUserId || isProfileNavigating) return;

        setIsProfileNavigating(true);
        try {
            const resp = await ApiCaller.Get(`/admin/service-user/${serviceUserId}`);
            const userDetails = resp?.data?.data?.userDetails;
            const hasServiceUserProfile = Boolean(userDetails?.basic?.fullName || userDetails?.basic?.email);

            navigate(hasServiceUserProfile ? `/service-user/${serviceUserId}` : `/service-provider/${serviceUserId}`);
        } catch (error) {
            console.log(error);
            navigate(`/service-provider/${serviceUserId}`);
        } finally {
            setIsProfileNavigating(false);
        }
    }

    const serviceProviderHandler = (quoteDetail) => {
        navigate(`/service-provider/${quoteDetail?.serviceProviderId}`)
    }

    return (
        <div className='card-container'>
            {
                isLoading ?
                    <Col className="user-table-loader-container">
                        <Loader.Circular />
                    </Col>
                    :
                    <>
                        {/* service user */}
                        <div className='user-card'>
                            <div className='booking-status-container'>
                                <Tag color={bookingDetailData?.bookingStatus == 0 ? '#FAB700' : bookingDetailData?.bookingStatus == 1 ? '#00B517' : bookingDetailData?.bookingStatus == 2 ? '#a6cdecff' : bookingDetailData?.bookingStatus == 3 ? '#90f5b2ff' : bookingDetailData?.bookingStatus == 4 ? '#0b5bf0ff' : bookingDetailData?.bookingStatus == 5 ? '#e84165' : ''} className='content'>
                                    {'Booking ' + statusMap[bookingDetailData?.bookingStatus]}
                                    {bookingDetailData?.isFlaged && bookingDetailData?.bookingStatus != 1 &&
                                        <span style={{ color: Colors.Primary, fontWeight: 'bold' }}> ( {now.diff(moment(bookingDetailData?.inProgressDate), "hours")} Hours )</span>}
                                </Tag>
                            </div>
                            {bookingDetailData?.isDisputed &&
                                <div className='w-full' style={{ display: "flex", justifyContent: "end" }}>
                                    <Tag color={"error"} className='m-0'>{'Disputed'}</Tag>
                                </div>}
                            <Text className="section-heading">User Information:</Text>
                            <div className='user-info-container'>
                                <div className='about-section'>
                                    <ProfileImage asAvatar src={bookingDetailData?.serviceUser?.profilePicture} size={80} className='avatar-border' />
                                    <div className='user-details'>
                                        <div className='user-name-and-role'>
                                            <span className='business-name'>{bookingDetailData?.serviceUser?.fullName}</span>
                                            <small className='user-role'>Service User</small>
                                        </div>
                                        <Button.Basic
                                            text={'View Profile'}
                                            className='view-profile-button'
                                            containerClassName='view-profile-button-container'
                                            onClick={serviceUserHandler}
                                            loading={isProfileNavigating}
                                            disabled={isProfileNavigating}
                                        />
                                    </div>
                                </div>
                                {/* <div className='divider' /> */}
                                <div className='details-box'>
                                    <div>
                                        <Text className="section-heading">Services Requested:</Text>
                                        <div className='user-services-container'>
                                            {
                                                bookingDetailData?.servicesRequested?.length > 0 ?
                                                    bookingDetailData?.servicesRequested?.map((service) => {
                                                        return (
                                                            <div className='su-requested-service-item-container' key={service?.id}>
                                                                <span className='services-icon-container'>
                                                                    <FaCheck color='#fff' size={6} />
                                                                </span>
                                                                {service?.name}
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    <p>No services Requested</p>
                                            }
                                        </div>
                                    </div>
                                    <div className='divider' />
                                    <div>
                                        <Text className="section-heading">Vehicle Registration Number:</Text>
                                        <span className='section-content'>{bookingDetailData?.vehicleRegistrationNo}</span>
                                    </div>
                                    <div className='divider' />

                                    <div>
                                        <Text className="section-heading">Booking Description:</Text>
                                        <span className='section-content booking-desc'>{bookingDetailData?.description ?? '-'}</span>
                                    </div>
                                    <div className='divider' />

                                    <div>
                                        <Text className="section-heading">Booking Created At:</Text>
                                        <span className='section-content'>{moment(bookingDetailData?.createdAt)?.format('DD-MMM-YYYY HH:MM')}</span>
                                    </div>
                                    <div className='divider' />

                                    <div className='location-container'>
                                        <span className='location-icon-container'>
                                            <FiMapPin color='#fff' />
                                        </span>
                                        <span className='section-content'>{bookingDetailData?.location?.address}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* services providers information */}
                        {
                            bookingDetailData?.bookingType == 'DIRECT' ?
                                // if quoteDetail have the SP info it will be shown follwing the fuctions conditions.
                                (((bookingDetailData?.bookingStatus == 4 || bookingDetailData?.bookingStatus == 1) && Array.isArray(bookingDetailData?.quotes) && bookingDetailData?.quotes?.some(quote => quote?.status === 'ACCEPTED')) || bookingDetailData?.bookingStatus == 6) ?
                                    <>
                                        <div className='su-sp-divider' />
                                        <div className='quote-details-container'>
                                            <Text className="section-heading">Provider Information:</Text>
                                            <div className='header-section'>
                                                <ProfileImage asAvatar src={quoteDetail?.serviceProvider?.imageUrl} size={80} className='avatar-border' />
                                                <div className='header-content'>
                                                    <div className='business-info'>
                                                        <div>
                                                            <span className='business-name'>{quoteDetail?.serviceProvider?.userDetail?.businessName ?? '-'}</span>
                                                            {/* badge */}
                                                        </div>
                                                        <div>
                                                            {/* acceptedQuote?.services */}
                                                            {
                                                                quoteDetail?.serviceProvider?.services?.length > 0 ? (
                                                                    <>
                                                                        {quoteDetail?.serviceProvider?.services
                                                                            .slice(0, 3)
                                                                            .map((service, index, arr) => {
                                                                                return (
                                                                                    <span key={service?.id}>
                                                                                        {service?.name}
                                                                                        {index !== arr.length - 1 && ", "}
                                                                                    </span>
                                                                                )
                                                                            }
                                                                            )}
                                                                        {quoteDetail?.serviceProvider?.services?.length > 3 && (
                                                                            <Tooltip
                                                                                title={
                                                                                    <div>
                                                                                        {quoteDetail?.serviceProvider?.services.map((service) => {
                                                                                            return (
                                                                                                <div key={service?.id}>{service?.name}</div>
                                                                                            )
                                                                                        })}
                                                                                    </div>
                                                                                }
                                                                            >
                                                                                ... Show more
                                                                            </Tooltip>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <span>No service available</span>
                                                                )
                                                            }
                                                        </div>
                                                        {/* <p className=''>
                                                        <Tag color={`${quoteDetail?.status == 'ACCEPTED' ? Colors.Primary : quoteDetail?.status == 'PENDING' ? Colors.BlueText : Colors.Danger}`}>{quoteDetail?.status}</Tag>
                                                    </p> */}
                                                    </div>
                                                    <Button.Basic
                                                        text={'View Profile'}
                                                        className='view-profile-button'
                                                        containerClassName='view-profile-button-container'
                                                        onClick={() => serviceProviderHandler(quoteDetail)}
                                                    />
                                                </div>
                                            </div>

                                            {/* <div className='divider' /> */}

                                            <div className='details-box'>
                                                <div>
                                                    <Text className="section-heading">Quoted Price:</Text>
                                                    <span className='font-wg-700-font-size-2rem'>£{quoteDetail?.price}</span>
                                                </div>
                                                <div className='divider' />
                                                <div>
                                                    <Text className="section-heading">Details of service:</Text>
                                                    <span className='section-content'>{quoteDetail?.additionalInfo ?? '-'}</span>
                                                </div>
                                                <div className='divider' />
                                                <div>
                                                    <p className='appointment-info mb-5'>
                                                        <span className='calendar-icon-container'>
                                                            <SlCalender color='#fff' />
                                                        </span>
                                                        <Text className="section-heading">Appointment - Date & Time:</Text>
                                                    </p>
                                                    <span className='section-content appointment-date-time-content' style={{ marginTop: '4px' }}>{quoteDetail?.date ? moment(quoteDetail?.date)?.format('DD MMM YYYY') : '-'} - {quoteDetail?.time ? quoteDetail?.time : '-'}</span>
                                                </div>
                                                <div className='divider' />
                                                <div>
                                                    <Text className='section-heading'>Commission Earn:</Text>
                                                    <span className='section-content'>£{quoteDetail?.adminCommission ?? '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </> :
                                    <>
                                        <div className='su-sp-divider' />
                                        <div className='quote-details-container'>
                                            <Text className="section-heading">Received Quotes:</Text>
                                            <div className='pending-quotes-listing-container'>
                                                {
                                                    bookingDetailData?.quotes
                                                        ?.map((quote) => {
                                                            return (
                                                                <div key={quote?.id} className='card' style={{ gap: '0rem' }}>
                                                                    <div className='about-section'>
                                                                        <div className='image-container'>
                                                                            <ProfileImage src={quote?.serviceProvider?.imageUrl} alt="provider" />
                                                                        </div>
                                                                        <div className='services'>
                                                                            <span className='name'>
                                                                                {quote?.serviceProvider?.userDetail?.businessName?.length > 21
                                                                                    ? quote?.serviceProvider?.userDetail?.businessName + '...'
                                                                                    : quote?.serviceProvider?.userDetail?.businessName
                                                                                    ?? '-'}
                                                                            </span>
                                                                            {
                                                                                quote?.serviceProvider?.services?.length > 0 ? (
                                                                                    <>
                                                                                        <div className='services-container'>
                                                                                            {quote?.serviceProvider?.services
                                                                                                .slice(0, 2)
                                                                                                .map((service, index, arr) => {
                                                                                                    return (
                                                                                                        <span key={service?.id} className='service-item'>
                                                                                                            {service?.name}
                                                                                                            {index !== arr.length - 1 && ", "}
                                                                                                        </span>
                                                                                                    )
                                                                                                }
                                                                                                )}
                                                                                            {quote?.serviceProvider?.services?.length > 2 && (
                                                                                                <Tooltip
                                                                                                    title={
                                                                                                        <div>
                                                                                                            {quote?.serviceProvider?.services.map((service) => {
                                                                                                                return (
                                                                                                                    <div key={service?.id}>{service?.name}</div>
                                                                                                                )
                                                                                                            })}
                                                                                                        </div>
                                                                                                    }
                                                                                                >
                                                                                                    <span className='service-item'>... Show more</span>
                                                                                                </Tooltip>
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <span>No service available</span>
                                                                                )
                                                                            }
                                                                            <span className='email'>{quote?.serviceProvider?.email ?? '-'}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='card-divider' />


                                                                    <div style={{ marginLeft: '10px' }}>
                                                                        <p className='appointment-info'>
                                                                            <span className='calendar-icon-container'>
                                                                                <SlCalender color='#fff' />
                                                                            </span>
                                                                            <span>{quote?.date ? moment(quote?.date)?.format('DD MMM YYYY') : '-'} - {quote?.time ? quote?.time : '-'}</span>
                                                                        </p>
                                                                    </div>
                                                                    <div className='card-divider' />

                                                                    <div style={{ marginLeft: '10px' }}>
                                                                        <p className='appointment-info'>
                                                                            <span className='calendar-icon-container' style={{ background: Colors.Primary }}>
                                                                                <FaPoundSign color='#fff' />
                                                                            </span>
                                                                            <span>{quote?.price ?? '-'}</span>
                                                                        </p>
                                                                    </div>

                                                                    <div className='card-divider' />

                                                                    {/* <div className='divider' /> */}

                                                                    <div style={{ marginLeft: '10px' }}>
                                                                        <p style={{ margin: 0, fontWeight: 600 }}>Description:</p>
                                                                        <span className='booking-desc'>{quote?.additionalInfo}</span>
                                                                    </div>
                                                                    <div className='card-divider' />

                                                                    <div style={{ marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                                                        {/* <span style={{ fontWeight: 600 }}>Status:</span> */}
                                                                        <Tag color={getQuoteStatusColor(quote?.status)} style={{ margin: 0, padding: '6px ', borderRadius: '6px' }}>
                                                                            {quote?.status || 'N/A'}
                                                                        </Tag>
                                                                        <div className=''>
                                                                            <Button.Basic
                                                                                text={'View Profile'}
                                                                                className='view-profile-button'
                                                                                containerClassName='view-profile-button-container'
                                                                                onClick={() => serviceProviderHandler(quote)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                }
                                            </div>
                                        </div>
                                    </>
                                :
                                bookingDetailData?.bookingType == 'QUOTE' ?
                                    // again if quoteDetail have the SP info and if it's not an array of sp's then this will be run and shown.
                                    quoteDetail && !Array.isArray(quoteDetail) ?
                                        <>
                                            <div className='su-sp-divider' />
                                            <div className='quote-details-container'>
                                                <Text className="section-heading">Provider Information:</Text>
                                                <div className='header-section'>
                                                    <ProfileImage asAvatar src={quoteDetail?.serviceProvider?.imageUrl} size={80} className='avatar-border' />
                                                    <div className='header-content'>
                                                        <div className='business-info'>
                                                            <div>
                                                                <span className='business-name'>{quoteDetail?.serviceProvider?.userDetail?.businessName ?? '-'}</span>
                                                                {/* badge */}
                                                            </div>
                                                            <div>
                                                                {/* acceptedQuote?.services */}
                                                                {
                                                                    quoteDetail?.serviceProvider?.services?.length > 0 ? (
                                                                        <>
                                                                            {quoteDetail?.serviceProvider?.services
                                                                                .slice(0, 3)
                                                                                .map((service, index, arr) => {
                                                                                    return (
                                                                                        <span key={service?.id}>
                                                                                            {service?.name}
                                                                                            {index !== arr.length - 1 && ", "}
                                                                                        </span>
                                                                                    )
                                                                                }
                                                                                )}
                                                                            {quoteDetail?.serviceProvider?.services?.length > 3 && (
                                                                                <Tooltip
                                                                                    title={
                                                                                        <div>
                                                                                            {quoteDetail?.serviceProvider?.services.map((service) => {
                                                                                                return (
                                                                                                    <div key={service?.id}>{service?.name}</div>
                                                                                                )
                                                                                            })}
                                                                                        </div>
                                                                                    }
                                                                                >
                                                                                    ... Show more
                                                                                </Tooltip>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <span>No service available</span>
                                                                    )
                                                                }
                                                            </div>
                                                            {/* <p className=''>
                                                        <Tag color={`${quoteDetail?.status == 'ACCEPTED' ? Colors.Primary : quoteDetail?.status == 'PENDING' ? Colors.BlueText : Colors.Danger}`}>{quoteDetail?.status}</Tag>
                                                    </p> */}
                                                        </div>
                                                        <Button.Basic
                                                            text={'View Profile'}
                                                            className='view-profile-button'
                                                            containerClassName='view-profile-button-container'
                                                            onClick={() => serviceProviderHandler(quoteDetail)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* <div className='divider' /> */}

                                                <div className='details-box'>
                                                    <div>
                                                        <Text className="section-heading">Quoted Price:</Text>
                                                        <span className='font-wg-700-font-size-2rem'>£{quoteDetail?.price}</span>
                                                    </div>
                                                    <div className='divider' />
                                                    <div>
                                                        <Text className="section-heading">Details of service:</Text>
                                                        <span className='section-content'>{quoteDetail?.additionalInfo ?? '-'}</span>
                                                    </div>
                                                    <div className='divider' />
                                                    <div>
                                                        <p className='appointment-info mb-5'>
                                                            <span className='calendar-icon-container'>
                                                                <SlCalender color='#fff' />
                                                            </span>
                                                            <Text className="section-heading">Appointment - Date & Time:</Text>
                                                        </p>
                                                        <span className='section-content appointment-date-time-content'>{quoteDetail?.date ? moment(quoteDetail?.date)?.format('DD MMM YYYY') : '-'} - {quoteDetail?.time ? quoteDetail?.time : '-'}</span>
                                                    </div>
                                                    <div className='divider' />
                                                    <div>
                                                        <Text className='section-heading'>Commission Earn:</Text>
                                                        <span className='section-content'>£{bookingDetailData?.adminEarnings ?? '-'}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        // else this will run to show all the sp's
                                        quoteDetail && quoteDetail?.length > 0 &&
                                        <>
                                            <div className='su-sp-divider' />
                                            <div className='quote-details-container'>
                                                <Text className="section-heading">Received Quotes:</Text>
                                                <div className='pending-quotes-listing-container'>
                                                    {
                                                        quoteDetail.map((quote) => {
                                                            return (
                                                                <div key={quote?.id} className='card'>
                                                                    <div className='about-section'>
                                                                        <div className='image-container'>
                                                                            <ProfileImage src={quote?.serviceProvider?.imageUrl} alt="provider" />
                                                                        </div>
                                                                        <div className='services'>
                                                                            <span className='name'>
                                                                                {quote?.serviceProvider?.userDetail?.businessName?.length > 21
                                                                                    ? quote?.serviceProvider?.userDetail?.businessName + ' ...'
                                                                                    : quote?.serviceProvider?.userDetail?.businessName
                                                                                    ?? '-'}
                                                                            </span>
                                                                            {
                                                                                quote?.serviceProvider?.services?.length > 0 ? (
                                                                                    <>
                                                                                        <div className='services-container'>
                                                                                            {quote?.serviceProvider?.services
                                                                                                .slice(0, 2)
                                                                                                .map((service, index, arr) => {
                                                                                                    return (
                                                                                                        <span key={service?.id} className='service-item'>
                                                                                                            {service?.name}
                                                                                                            {index !== arr.length - 1 && ", "}
                                                                                                        </span>
                                                                                                    )
                                                                                                }
                                                                                                )}
                                                                                            {quote?.serviceProvider?.services?.length > 2 && (
                                                                                                <Tooltip
                                                                                                    title={
                                                                                                        <div>
                                                                                                            {quote?.serviceProvider?.services.map((service) => {
                                                                                                                return (
                                                                                                                    <div key={service?.id}>{service?.name}</div>
                                                                                                                )
                                                                                                            })}
                                                                                                        </div>
                                                                                                    }
                                                                                                >
                                                                                                    <span className='service-item'>... Show more</span>
                                                                                                </Tooltip>
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <span>No service available</span>
                                                                                )
                                                                            }
                                                                            <span className='email'>{quote?.serviceProvider?.email ?? '-'}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='card-divider' />



                                                                    <div style={{ marginLeft: '10px' }}>
                                                                        <p className='appointment-info'>
                                                                            <span className='calendar-icon-container'>
                                                                                <SlCalender color='#fff' />
                                                                            </span>
                                                                            <span>{quote?.date ? moment(quote?.date)?.format('DD MMM YYYY') : '-'} - {quote?.time ? quote?.time : '-'}</span>
                                                                        </p>
                                                                    </div>
                                                                    <div className='card-divider' />

                                                                    <div style={{ marginLeft: '10px' }}>
                                                                        <p className='appointment-info'>
                                                                            <span className='calendar-icon-container' style={{ background: Colors.Primary }}>
                                                                                <FaPoundSign color='#fff' />
                                                                            </span>
                                                                            <span>{quote?.price ?? '-'}</span>
                                                                        </p>
                                                                    </div>

                                                                    <div className='card-divider' />

                                                                    {/* <div className='divider' /> */}

                                                                    <div style={{ marginLeft: '10px' }}>
                                                                        <p style={{ margin: 0 }}>Description:</p>
                                                                        <span className='booking-desc'>{quote?.additionalInfo}</span>
                                                                    </div>
                                                                    <div className='card-divider' />

                                                                    <div style={{ marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                                                                        {/* <span style={{ fontWeight: 600 }}>Status:</span> */}
                                                                        <Tag color={getQuoteStatusColor(quote?.status)} style={{ margin: 0, padding: '6px', borderRadius: '6px' }}>
                                                                            {quote?.status || 'N/A'}
                                                                        </Tag>
                                                                        <div >
                                                                            <Button.Basic
                                                                                text={'View Profile'}
                                                                                className='view-profile-button'
                                                                                containerClassName='view-profile-button-container'
                                                                                onClick={() => serviceProviderHandler(quote)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    :
                                    ""
                        }
                    </>
            }
        </div>
    );
};

export default BookingCard;